module.exports = "attribute vec2 aPoint;\r\nuniform vec2 uCanvasSize;\r\n\r\nvoid main(void) {\r\n  gl_Position = vec4(aPoint * mat2( 2.0/uCanvasSize.x,0, 0,-2.0/uCanvasSize.y ) + vec2(-1, 1), 0, 1);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/simple-gl/rect.v.glsl
// module id = 7
// module chunks = 0